import Analytics from "components/components/Analytics";
import { DataExportToastManager } from "components/components/AppToast/DataExportToastManager";
import { RemitUploadToastManager } from "components/components/AppToast/RemitUploadToastManager";
import ErrorBoundary from "components/components/ErrorBoundary/ErrorBoundary";
import Footer from "components/layout/Footer/Footer";
import Header from "components/layout/Header/Header";
import {
  DataExportContext,
  DataExportReducer,
} from "contexts/DataExportContext";
import {
  RemitSubmissionState,
  RemitUploadContext,
  RemitUploadReducer,
} from "contexts/RemitUploadContext";
import { SwaggerFileProvider } from "contexts/SwaggerFileContext";
import { useIrisLoginModalCookie } from "hooks/useIrisLoginModalCookie";
import React, { useReducer } from "react";
import { Toaster } from "react-hot-toast";
import { useLocation } from "react-router-dom";

interface Props {
  children: JSX.Element;
}

const Layout: React.FC<Props> = ({ children }: Props) => {
  const [dataExportCountState, dataExportCountDispatch] = useReducer(
    DataExportReducer,
    { count: 0, errorCount: 0, toastVisible: false, toastId: 100 }
  );

  const [remitUploadState, remitUploadDispatch] = useReducer(
    RemitUploadReducer,
    {
      submissionState: RemitSubmissionState.Idle,
      toastVisible: false,
      toastId: 200,
    }
  );

  useIrisLoginModalCookie();

  const location = useLocation();

  return (
    <>
      <DataExportContext.Provider
        value={{
          state: dataExportCountState,
          dispatch: dataExportCountDispatch,
        }}
      >
        <RemitUploadContext.Provider
          value={{
            state: remitUploadState,
            dispatch: remitUploadDispatch,
          }}
        >
          <SwaggerFileProvider>
            <>
              <Analytics />
              <Header />
              <main className="container content">
                <ErrorBoundary location={location}>{children}</ErrorBoundary>
              </main>
              <Footer />
              <Toaster position="bottom-right" />
              <DataExportToastManager />
              <RemitUploadToastManager />
            </>
          </SwaggerFileProvider>
        </RemitUploadContext.Provider>
      </DataExportContext.Provider>
    </>
  );
};

export default Layout;
